import { IRequestForDonorReview } from "@nkr/models/index";
import { LabelWrapper, TableWrapper } from "./styles";

interface IProps {
    list: IRequestForDonorReview[],
    urgent: boolean
}

const RequestForDonorReview = (props: IProps) => {
    const getResponseDateLabel = (item: IRequestForDonorReview) => {
        let bsStyle = null;
        let style = null;

        if (item.daysLate < 0) {
            bsStyle = 'success';
        }

        if (item.daysLate == 0) {
            style = { backgroundColor: '#FF8633', color: 'white' };
        }

        if (item.daysLate > 0) {
            bsStyle = 'danger';
        }

        return <LabelWrapper bsStyle={bsStyle} style={style}>{item.responseDeadlineActual}</LabelWrapper>;
    };

    return (
        <div style={{ height: props.list.length > 25 ? 600 : null, overflowY: props.list.length > 25 ? 'scroll' : null }}>
            <TableWrapper className="table table-condensed table-striped table-bordered">
                <thead>
                    <tr>
                        <th rowSpan={2}></th>
                        <th colSpan={2}>Donor</th>
                        <th colSpan={2}>Recipient</th>
                        <th rowSpan={2}>Date Requested</th>
                        <th rowSpan={2}>Response Deadline</th>
                    </tr>
                    <tr>
                        <th>Center</th>
                        <th>Alias</th>
                        <th>Center</th>
                        <th>Alias</th>
                    </tr>
                </thead>
                <tbody>
                    {props.list.map((item, index) =>
                        {                           
                            if(item.remoteDonorCenter != null)
                            {
                                return(
                                    <tr key={index}>
                                        <td><a href={`/center/${item.recipientCenterId}/recipient/${item.recipientId}/evaluate-donor/${item.donorId}`} target="_blank">Review</a></td>
                                        <td>{item.donorCenter} (<span style={{ color: 'red' }}>{item.remoteDonorCenter}</span>)</td>
                                        <td>{item.donorAlias}</td>
                                        <td>{item.recipientCenter}</td>
                                        <td>{item.recipientAlias}</td>
                                        <td>{item.dateRequested}</td>
                                        <td>{getResponseDateLabel(item)}</td>
                                    </tr>
                                );
                            }
                            else
                            {
                                return(
                                    <tr key={index}>
                                        <td><a href={`/center/${item.recipientCenterId}/recipient/${item.recipientId}/evaluate-donor/${item.donorId}`} target="_blank">Review</a></td>
                                        <td>{item.donorCenter}</td>
                                        <td>{item.donorAlias}</td>
                                        <td>{item.recipientCenter}</td>
                                        <td>{item.recipientAlias}</td>
                                        <td>{item.dateRequested}</td>
                                        <td>{getResponseDateLabel(item)}</td>
                                    </tr>
                                );
                            }
                        }
                    )}
                </tbody>
            </TableWrapper>
        </div>
    );
}

export default RequestForDonorReview;